import { get, set } from 'lodash';
import { getSyncDate } from 'site-modules/shared/components/profile/idm/idm-utils';

export const EMAIL_SUBSCRIPTIONS = [
  {
    title: 'Expert reviews, road tests and newsletters',
    id: 'content_series',
  },
  {
    title: 'Car shopping tips',
    id: 'welcome_series',
  },
  {
    title: 'Inventory search alerts',
    id: 'inventory_series',
  },
  {
    title: 'Price drop alerts',
    id: 'price_drop_alerts',
  },
  {
    title: 'Appraisal offer alerts',
    id: 'appraisal_series',
  },
];

/**
 * Gets and flattens IDM values
 * @param data IDM data
 * @returns {Object}  With required IDM values
 */
export const getIdmValues = data => {
  const idmValues = EMAIL_SUBSCRIPTIONS.reduce(
    (acc, item) => ({
      ...acc,
      [item.id]: !get(data, `marketing.campaigns.${item.id}.unsubscribedTs`),
    }),
    {}
  );
  return idmValues;
};

/**
 * Filters only updated fields, splits up phone and address values
 * @param initialFormValues  Initial form values
 * @param formValues  Values from form after submit
 * @returns {Object}  With changed fields
 *
 */
export const filterChangedValues = (initialFormValues, formValues) => {
  const resultValues = {};
  Object.keys(initialFormValues).forEach(key => {
    if (initialFormValues[key] !== formValues[key]) {
      resultValues[key] = formValues[key];
    }
  });

  return resultValues;
};

/**
 *
 * @param data Array values for update. This array is splice of EMAIL_SUBSCRIPTIONS
 * @param action Value can be only 'subscribe' or 'unsubscribe'
 * @returns {Object} With updated IDM values
 */
export const createDataToSubscriptions = (data, action) => {
  if (!data.length) return null;
  const choseMethod = {
    subscribe: 'DELETE',
    unsubscribe: 'UPDATE',
  };
  const idmValues = {};
  const date = getSyncDate();
  data.forEach(item => {
    set(idmValues, `marketing.campaigns.${item}.channels`, ['Email']);
    set(idmValues, `marketing.campaigns.${item}.unsubscribedTs`, date);
  });

  return { values: idmValues, method: choseMethod[action] };
};
